import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Alerts as SchemaAlerts } from '../schemas/Alerts';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Alerts
 */
export const GetAlertsContentType = '' as const;
export type GetAlertsRequest = void;
export type GetAlertsResponses = LinkCommonErrorResponses & {
    /**
     * @description List of active alerts
     */
    '200': {
        'application/json': SchemaAlerts;
    };
};
export type GetAlertsResponseSuccess = GetAlertsResponses['200']['application/json'];
export type GetAlertsSearchParams = {
    per_page?: number;
    page?: number;
};
export type GetAlertsPathParameters = undefined;
export const GetAlertsUrl = '/alerts' as const;
export const GetAlertsMethod = 'GET' as const;
export const getGetAlertsUrl = (_params?: GetAlertsPathParameters) => GetAlertsUrl;
